import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { APPROVAL_SURGE_TEMPLATE, APPROVAL_SURGE_TEMPLATE_SUCCESS, APPROVAL_SURGE_TEMPLATE_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* approveSurgeTemplate({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { templateId, approvalType } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-templates/${templateId}/${approvalType}`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: APPROVAL_SURGE_TEMPLATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: APPROVAL_SURGE_TEMPLATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: APPROVAL_SURGE_TEMPLATE_ERROR, payload: error });
  }
}

export function* watchapproveSurgeTemplate() {
  yield takeEvery(APPROVAL_SURGE_TEMPLATE, approveSurgeTemplate);
}

function* approveSurgeTemplateSaga() {
  yield all([fork(watchapproveSurgeTemplate)]);
}

export default approveSurgeTemplateSaga;
